// Premium hover: the contrast colour floods each button from where the cursor
// entered, and on a real pointer the button leans a few pixels toward it.
// The fill is picked from the button's own background so it always contrasts.
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const INK = '#45200a';
  const CREAM = '#fdf8f3';
  const BRAND = '#e08040';
  const PULL = 6;

  const rgb = (value) => (value.match(/[\d.]+/g) || []).map(Number);
  const luminance = ([r, g, b]) => (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;

  const isDark = (color) => {
    const [r, g, b, a = 1] = rgb(color);
    return a > 0.2 && luminance([r, g, b]) < 0.35;
  };

  // The first solid background behind the button, i.e. the panel it sits on
  const groundBehind = (el) => {
    for (let node = el.parentElement; node; node = node.parentElement) {
      const [, , , a = 1] = rgb(getComputedStyle(node).backgroundColor);
      if (a > 0.2) return getComputedStyle(node).backgroundColor;
    }
    return 'rgb(255, 255, 255)';
  };

  const setFill = (el) => {
    if (el.classList.contains('header__link')) return;
    // The flood has to stand out from the button and from the panel around it:
    // an ink flood on a light button that sits on an ink panel would make the
    // button vanish. Dark buttons, and any button on a dark panel, flood with
    // the brand orange; the rest flood with ink.
    const onDark = isDark(getComputedStyle(el).backgroundColor) || isDark(groundBehind(el));
    el.style.setProperty('--fill', onDark ? BRAND : INK);
    el.style.setProperty('--fill-text', onDark ? INK : CREAM);
  };

  const target = (event) => event.target.closest && event.target.closest('.btn, .header__link');

  document.addEventListener('pointerover', (event) => {
    const el = target(event);
    if (!el || el.contains(event.relatedTarget)) return;
    if (!el.style.getPropertyValue('--fill')) setFill(el);
    const box = el.getBoundingClientRect();
    el.style.setProperty('--hx', `${event.clientX - box.left}px`);
    el.style.setProperty('--hy', `${event.clientY - box.top}px`);
  });

  if (reduced) return;

  document.addEventListener('pointermove', (event) => {
    const el = target(event);
    if (!el || !el.classList.contains('btn')) return;
    const box = el.getBoundingClientRect();
    const x = (event.clientX - box.left) / box.width - 0.5;
    const y = (event.clientY - box.top) / box.height - 0.5;
    el.style.setProperty('--mx', `${(x * PULL).toFixed(2)}px`);
    el.style.setProperty('--my', `${(y * PULL).toFixed(2)}px`);
  });

  document.addEventListener('pointerout', (event) => {
    const el = target(event);
    if (!el || el.contains(event.relatedTarget)) return;
    const box = el.getBoundingClientRect();
    el.style.setProperty('--hx', `${event.clientX - box.left}px`);
    el.style.setProperty('--hy', `${event.clientY - box.top}px`);
    el.style.setProperty('--mx', '0px');
    el.style.setProperty('--my', '0px');
  });
})();
